import { connect } from 'react-redux';
import { selectUserName, selectUserEmail } from 'src/store/entities/user/selectors';
import Portal from './portal';

const PortalWithAuth = ({ userName, userEmail }) => {
  if (!userEmail || !userName) {
    return null;
  }

  return (
    <>
      <Portal email={userEmail} name={userName} />
    </>
  );
};

const mapStateToProps = (state) => ({
  userName: selectUserName(state),
  userEmail: selectUserEmail(state),
});

const Container = connect(mapStateToProps)(PortalWithAuth);

export default Container;
